/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IMediaGalleryThumbnailItemViewProps, IMediaGalleryThumbnailsViewProps } from '@msdyn365-commerce-modules/media-gallery';
import { IMediaGalleryViewProps } from './dobbies-media-gallery';
import { DobbiesMediaGalleryZoomedView } from './components/media-gallery-zoomed-view';
import Button from 'reactstrap/lib/Button';
import { VsiCustomBadges } from '../../themes/dobbies/views/custom-components/vsi-custom-badges';
import { CustomCarousel } from '../../themes/dobbies/views/custom-components/custom-carousel';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { Thumbnails, MediaGallery, Modal } = props;
    return (
        <Module {...MediaGallery}>
            <Node tag='div' className='position-relative order-one'>
                <CustomCarousel
                    mediaGalleryItems={props.mediaGalleryItems}
                    thumbnailActiveIndex={props.activeIndex}
                    onNext={props.next}
                    onPrevious={props.previous}
                    onGoToIndex={props.goToIndex}
                />
                <VsiCustomBadges
                    productData={{ ...props.data.product.result, AttributeValues: props.data.productAttributes.result }}
                    context={props.context}
                    mode='image'
                />
                <Button className='zoom-btn' onClick={props.clickToZoom}>
                    <span>Zoom</span>
                    <i className='zoom-icon'></i>
                </Button>
            </Node>
            {Modal}
            {_renderThumbnails(Thumbnails)}
            <DobbiesMediaGalleryZoomedView
                shouldRenderZoomedView={props.shouldZommedViewBeRendered ? true : false}
                images={props.zoomedViewImages}
                currIndex={props.currZoomedViewIndex ? props.currZoomedViewIndex : 0}
                gridSettings={props.context.request.gridSettings!}
                productAttributes={props.productAttributes || []}
                onViewClosed={() => {
                    if (props.onZoomViewClosed) {
                        props.onZoomViewClosed();
                    }
                }}
            />
        </Module>
    );
};

const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
    const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

    return (
        <Node {...ThumbnailsContainerProps}>
            <Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
        </Node>
    );
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
    const { ThumbnailItemContainerProps, Picture } = thumbnail;

    return (
        <Node {...ThumbnailItemContainerProps} key={thumbnail.Picture.key || ''}>
            {Picture}
        </Node>
    );
};

export default MediaGalleryView;
